<template>
<div class="medical-records ">
        <div class="row mb-4 food-section">
          <div class="col-12 meals-section ">
            <div class="card border-0">
              <div class="card-body bg-white border-radius-5 p-4">
                <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area">
                  <div class="col-md-12">
                    <h2>Breakfast Meals</h2>
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="bg-body border-radius-5 p-3 d-flex align-items-center">
                      <figure class="mb-0"><img src="../../../../static/website/images/food-img-1.png"></figure>
                      <div class="pl-3">
                        <h3 class="mb-0">Avocado with egg</h3>
                        <p class="mb-0">220 g - 67 Cal</p>
                        <ul class="d-flex mb-0">
                          <li><a href="#"><i class="icon icon-star"></i> </a></li>
                          <li><a href="#"><i class="icon icon-star"></i> </a></li>
                          <li><a href="#"><i class="icon icon-star"></i> </a></li>
                          <li><a href="#"><i class="icon icon-star"></i> </a></li>
                          <li><a href="#"><i class="icon icon-star"></i> </a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 NutritionFacts mt-5">
                    <h2>Nutrition Facts</h2>
                    <ul class="d-flex">
                      <li class="pr-3">
                        <div class="bg-body border-radius-5 p-3 facts facts-bg-1 text-center">
                          <h3 class="mb-0">278.8</h3>
                          <p class="mb-0">Calories</p>
                        </div>
                      </li>
                      <li class="pr-3">
                        <div class="bg-body border-radius-5 p-3 facts facts-bg-2 text-center">
                          <h3 class="mb-0">29.7 g</h3>
                          <p class="mb-0">Carbs</p>
                        </div>
                      </li>
                      <li class="pr-3">
                        <div class="bg-body border-radius-5 p-3 facts facts-bg-3 text-center">
                          <h3 class="mb-0">8.0 g</h3>
                          <p class="mb-0">Protein</p>
                        </div>
                      </li>
                      <li class="pr-3">
                        <div class="bg-body border-radius-5 p-3 facts facts-bg-4 text-center">
                          <h3 class="mb-0">14.3 g</h3>
                          <p class="mb-0">Fat</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-12 NutritionFacts mt-5">
                    <h2>Micronutrients</h2>
                    <div class="row no-gutters">
                      <div class="col pr-3 mb-3">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Energy</h3>
                          <p class="mb-0">279Kcal</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Lactose</h3>
                          <p class="mb-0">0g</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Alcohol, ethyl</h3>
                          <p class="mb-0">0g</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Iron, Fe</h3>
                          <p class="mb-0">1mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Magnesium, Mg</h3>
                          <p class="mb-0">35 mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Posphorus, P</h3>
                          <p class="mb-0">136mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Water</h3>
                          <p class="mb-0">0.11</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Caffeine</h3>
                          <p class="mb-0">0mg</p>
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Water</h3>
                          <p class="mb-0">0.11</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Caffeine</h3>
                          <p class="mb-0">0mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Calcuim, Ca</h3>
                          <p class="mb-0">37mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Energy</h3>
                          <p class="mb-0">279Kcal</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Lactose</h3>
                          <p class="mb-0">0g</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Alcohol, ethyl</h3>
                          <p class="mb-0">0g</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Iron, Fe</h3>
                          <p class="mb-0">1mg</p>
                        </div>
                      </div>
                      <div class="col pr-2 mb-2">
                        <div class="bg-body border-radius-5 p-2 Energy text-left">
                          <h3 class="mb-0">Magnesium, Mg</h3>
                          <p class="mb-0">35 mg</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
	export default {
        name: 'meals-single',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/recommended_diet/meals-single.vue